import { queryOptions, useQueries } from "@tanstack/react-query";

import { getQueryParams } from "app/pages/industry-analysis/common/getQueryParams";
import type { ICategory } from "app/common/services/categoryService.types";
import { DefaultFetchService } from "app/services/fetchService";

import type { RawData } from "../types";

const ENDPOINT = "api/Market/Difficulty";

interface UseMarketDifficultyDataResult {
    data: Array<RawData | undefined>;
    isLoading: boolean;
    errors: Array<Error | null>;
}

const fetchService = DefaultFetchService.getInstance();

const createQuery = (category: ICategory) => {
    const baseQueryParams = getQueryParams();
    const queryParams = {
        ...baseQueryParams,
        keys: category.forApi,
        category: category.categoryId,
        categoryHash: category.isCustomCategory ? category.categoryHash : "",
        latest: "1m",
    };

    return queryOptions({
        queryKey: [ENDPOINT, queryParams],
        queryFn: () => fetchService.get<RawData>(ENDPOINT, queryParams),
        enabled: !!category,
    });
};

export const useMarketDifficultyData = (categories: ICategory[]): UseMarketDifficultyDataResult => {
    const queries = useQueries({
        queries: categories.map((category) => createQuery(category)),
        combine: (results) => ({
            data: results.map((result) => result.data),
            isLoading: results.some((result) => result.isLoading),
            errors: results.map((result) => result.error),
        }),
    });

    return queries;
};
